import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const usePreventRefresh = () => {
  const navigate = useNavigate();

  useEffect(() => {
      const handleBeforeUnload = (event) => {
          // 새로고침 방지 설정
          event.preventDefault();
          event.returnValue = ''; // 브라우저 호환성 유지

          // // 새로고침 발생 시 '/'로 이동
          // if (window.location.pathname !== '/') {
          //     navigate('/');
          // }
      };

      // 새로고침 시 이벤트 연결
      window.addEventListener('beforeunload', handleBeforeUnload);

      // 컴포넌트 언마운트 시 이벤트 제거
      return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
      };
  }, [navigate]);

};

export default usePreventRefresh;
